import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=9096175c"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__